export default __webpack_public_path__ + "static/char-02-62ba2a893efff53c60042743e5341b63.webp";